import React, { useEffect, useState } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import useAxiosPrivate from '../../context/hooks/useAxiosPrivate';
import { Table, Form, Button, Spinner } from 'react-bootstrap';
import '../../appstyles/ClientsCSS/ClientsList.css';

const AssignInventory = () => {
  const axiosInstance = useAxiosPrivate();
  const { quoteId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { productParams } = location.state || { productParams: [] };
  const [stockResults, setStockResults] = useState([]); 
  const [selectedInventories, setSelectedInventories] = useState({}); // { product_id: inventory_id }
  const [loading, setLoading] = useState(false);


  useEffect(() => {
  const fetchStockData = async () => {
    const newStockResults = [];
    setLoading(true);

    for (const product of productParams) {
      const response = await axiosInstance.get(
        `/api/logistics-inventory/?page=1&size=30&product_id=${product.product_id}&stock=${product.quantity}`
      );

      const inventoryData = response.data.data;
      const product_name = product.product_name || 'Nombre no disponible';

      newStockResults.push({
        product_id: product.product_id,
        product_name,
        inventoryList: inventoryData
      });
    }

    setLoading(false);
    setStockResults(newStockResults);
  };

  if (productParams.length > 0) {
    fetchStockData();
  }
  }, [productParams, axiosInstance]);

  const allSelected = productParams.length > 0 &&
  productParams.every(p => selectedInventories[p.product_id]);

  const handleSelectInventory = (product_id, inventory_id) => {
  setSelectedInventories(prev => {
    if (prev[product_id] === inventory_id) {
      const updated = { ...prev };
      delete updated[product_id];
      return updated;
    }
    return { ...prev, [product_id]: inventory_id };
  });
  };

  const handleSubmit = async () => {
  try {
    const requests = Object.entries(selectedInventories).map(
      ([product_id, inventory_id]) =>
        axiosInstance.post('/api/logistics-inventory/assign-inventory/', {
          inventory_id,
          quote_id: parseInt(quoteId)
        })
    );

    await Promise.all(requests);
    alert('Inventarios asignados exitosamente');
    navigate(`/quote/details/${quoteId}`); 
  } catch (error) {
    console.error('Error al asignar inventarios:', error);
    alert('Ocurrió un error al asignar el inventario por producto.');
  }
  };
  
  return (
    <div className='maestros-list' style={{ padding: '30px' }}>
      <h2>Inventario por Producto</h2>
      <p style={{margin: '5px 0', fontSize: '17px'}}>
        A continuación se muestra el inventario disponible para cada producto
      </p>
      <hr />

      {loading ? ( 
          <div className='loading-container'>
          <p style={{fontFamily: 'Roboto, sans-serif'}}>Cargando...</p>
          <Spinner animation="border" variant="info" style={{width: '4.5rem', height: '4.5rem'}} />
          </div>
        ) : (
        <div>
        {stockResults.map(({ product_id, product_name, inventoryList }) => (
        <div key={product_id} style={{ marginBottom: '40px' }}>
          <h4 style={{color: '#602548', fontWeight: '700'}}>Inventario para: {product_name}</h4>

          <Table striped bordered hover responsive
            style={{margin: '0px'}}
          >
            <thead className='table-header'>
              <tr>
                <th>Consecutivo</th>
                <th>Nombre Proveedor</th>
                <th>Stock</th>
                <th>Unidad</th>
                <th>Estado</th>
                <th>Estado de Tracking</th>
                <th>Seleccionar</th>
              </tr>
            </thead>
            <tbody>
              {inventoryList.map(inventory => (
                <tr key={inventory.inventory_id}>
                  <td>{inventory.parent_quote?.consecutive}</td>
                  <td>{inventory.parent_quote?.supplier_name}</td>
                  <td>{inventory.stock}</td>
                  <td>{inventory.unit}</td>
                  <td>{inventory.status}</td>
                  <td>{inventory.tracking_status}</td>
                  <td style={{ textAlign: 'center' }}>
                    <Form.Check
                      onChange={() => handleSelectInventory(product_id, inventory.inventory_id)}
                      checked={selectedInventories[product_id] === inventory.inventory_id}
                      disabled={
                        selectedInventories[product_id] !== undefined &&
                        selectedInventories[product_id] !== inventory.inventory_id
                      }
                      style={{ cursor: 'pointer', margin: '0px 5px 5px 0px' }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <hr />
        </div>
        ))}
        </div>
      )} 
      
      
      {/*Botones*/}
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '5px',
        }}
      > 
      <Button 
        variant="primary" 
        style={{marginTop: '20px', width: '20%', backgroundColor: '#025C5A', borderColor: '#025C5A'}}
        onClick={handleSubmit}
        disabled={!allSelected}
      >
        Asignar Stock
      </Button>

      <Button 
        variant="secondary" 
        style={{marginTop: '20px', width: '20%'}}
        onClick={() => navigate(`/quote/details/${quoteId}`)}
      >
          Volver
      </Button>
      </div>
      

    </div>
  );
};

export default AssignInventory